module.exports = __webpack_public_path__ + "img/74.ba4a97d7.jpg";